import * as React from 'react'
import { Form } from 'react-bootstrap'
import { DamageT } from '../../../../types/JobWorker'


interface DamageProps {
    damage : DamageT
    index : number
    removeDamage(index : number) : void
}

// export interface DamageT {
//     id : number // If id==-1, then return as `no damage` from db; if input is not-empty, it will return a non "-1" value
//     amount : number
//     cause : string  // Accident | Breach
//     damageDate : string
//     damageType : string     // TODO - Enumerate damage types
//     itemDamaged : string    // TODO - Enumerate possible items
// }

const Damage : React.FunctionComponent<DamageProps> = ({damage, index, removeDamage}) : JSX.Element => {
    return (
        <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 30px'}}>
            <span>
                <Form.Label>Date</Form.Label>
                <Form.Control
                    className='input-material' />
            </span>
            <span>
                <Form.Label>Item</Form.Label>
                <Form.Control
                    as='select'
                    className='input-material'>
                </Form.Control>
            </span>
            <span>
                <Form.Label>Type</Form.Label>
                <Form.Control
                    as='select'
                    className='input-material'>
                </Form.Control>
            </span>
            <span>
                <Form.Label>Cause</Form.Label>
                <Form.Control
                    as='select'
                    className='input-material'>
                    <option></option>
                    <option value='accident'>Accident</option>
                    <option value='breach'>Protocol Breach</option>
                </Form.Control>
            </span>
            <span>
                <Form.Label>Amount</Form.Label>
                <Form.Control
                    className='input-material' />
            </span>
            <span onClick={() : void => {removeDamage(index)}}>
                x
            </span>
        </div>
    )
}

export default Damage